export default __webpack_public_path__ + "static/media/Flask-3s-200px.63124ad4.svg";